import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import type { CadenceName } from "@hub/shared";
import { IconButton, toast } from "@/ui";
import { useEngineMutation } from "@/engine/hooks";
import { Page } from "@/app/layout/Page";
import { GroupForm } from "./GroupForm";

export function NewGroupPage() {
  const navigate = useNavigate();
  const create = useEngineMutation("createGroup", { invalidate: ["listGroups"] });
  return (
    <Page before={<IconButton label="Back" onClick={() => navigate(-1)}><ArrowLeft size={16} /></IconButton>} title="New group">
      <GroupForm
        submitLabel="Create group"
        loading={create.isPending}
        onCancel={() => navigate(-1)}
        onSubmit={(d) => create.mutate({ name: d.name, description: d.description || null, kind: d.kind, filter: d.kind === "smart" ? d.filter : null, color: d.color || null, parentId: d.parentId, reconnectCadence: (d.reconnectCadence || null) as CadenceName | null }, { onSuccess: (g) => { toast(`Created ${g.name}`, "success"); navigate(`/group/${g.id}`); } })}
      />
    </Page>
  );
}
